import productsAPI from "@/api/products";
import moment from 'moment';

const getDefaultState = () => ({
  statusHistory: [],
  isStatusHistoryLoading: false,
  isStatusHistoryError: false,
  isStatusHistoryErrorResponse: null,
  paginationConfigs: {
    paginationCount: 0,
    itemsPerPage: 25,
    page: 1,
  },
});

const state = getDefaultState();

const mutations = {
  FETCH_STATUS_HISTORY_BEGIN(state) {
    state.isStatusHistoryLoading = true;
    state.isStatusHistoryError = false;
    state.isStatusHistoryErrorResponse = null;
  },
  FETCH_STATUS_HISTORY_SUCCESS(state, payload) {
    state.statusHistory = payload.data;
    state.paginationConfigs.paginationCount = parseInt(payload.headers['pagination-count']);
    state.paginationConfigs.itemsPerPage = parseInt(payload.headers['pagination-limit']);
    state.paginationConfigs.page = parseInt(payload.headers['pagination-page']);
    state.isStatusHistoryLoading = false;
  },
  FETCH_STATUS_HISTORY_ERROR(state) {
    state.isStatusHistoryLoading = false;
    state.isStatusHistoryError = true;
    state.isStatusHistoryErrorResponse = null;
  },
  
  RESET_STATUS_HISTORY(state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  async fetchStatusHistory({ commit, dispatch }, { p_id, options }) {
    commit("FETCH_STATUS_HISTORY_BEGIN");
    try {
      let res = await productsAPI.getStatusHistory({ p_id, options: options });
      commit("FETCH_STATUS_HISTORY_SUCCESS", res);
    } catch(error) {
      commit("FETCH_STATUS_HISTORY_ERROR", error);
      dispatch("alerts/setAlert", { type: "error", message: error.response.data.message }, { root: true });
    }
  },
};

const getters = {
  getStatusHistory: state => {
    const statusHistory = [ ...state.statusHistory ];

    return statusHistory.reduce((acc, obj, index) => {
      const created = formatDateTime(obj.creation_timestamp,'YYYY-MM-DD');
      const prevStatusCreated = (statusHistory[index-1]!==undefined) ? formatDateTime(statusHistory[index-1].creation_timestamp,'YYYY-MM-DD') : formatDateTime(obj.creation_timestamp,'YYYY-MM-DD');
      
      const { paginationCount, itemsPerPage, page } = state.paginationConfigs;
      const calculatedPage = Math.floor((paginationCount + itemsPerPage - 1) / itemsPerPage);
      const days = (page === 1 && index === 0) ? moment(days).diff(moment(created), 'days') : moment(prevStatusCreated).diff(moment(created), 'days');

      acc.push({
        datetime: formatDateTime(obj.creation_timestamp,'YYYY-MM-DD HH:mm A'),
        days: days,
        status: obj.status,
        user: obj.user,
        forced: obj.forced,
      });

      return acc;
    }, []);
  },
  getIsStatusHistoryLoading: state => state.isStatusHistoryLoading,
  getIsStatusHistoryError: state => state.isStatusHistoryError,
  getIsStatusHistoryErrorResponse: state => state.isStatusHistoryErrorResponse,
  getPaginationConfigs: state => state.paginationConfigs
};

const formatDateTime = (dt, format) => {
  return moment(dt).format(format);
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
